export default __webpack_public_path__ + "static/media/fu.2d6af8f5.jpg";